import {
  getAction,
  postAction
} from '@/api/api'

const staffCompanyName = (params) =>
  getAction('/staff/system/companyInfo', params)
//管理员
// 用户账号部分
const staffLogin = (params) => postAction('/staff/auth/login', params)
const staffLogout = (params) => postAction('/staff/auth/logout', params)
const staffRestPassword = (params) =>
  postAction('/staff/user/updatePwd', params)

// 用户信息部分
const staffUserInfo = () => getAction('/staff/user/info')
const staffExpandUpdate = (params) =>
  postAction('/staff/user/updateInfo', params)
const staffSalaryReport = (params) =>
  getAction('/staff/salaryReport/list', params)
const staffSalaryInfo = () => getAction('/staff/user/salaryInfo')

export {
  staffCompanyName,
  staffLogin,
  staffLogout,
  staffRestPassword,
  staffUserInfo,
  staffExpandUpdate,
  staffSalaryReport,
  staffSalaryInfo
}